import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { MyContext } from "../hooks/MyContextProvider";
import Authentication from "../Pages/Authentication";
import ShoppingCart from "../Pages/ViewCart";
import {
  Search,
  User,
  ShoppingBag,
  Menu,
  X,
  ChevronDown,
  Heart,
} from "lucide-react";
import useBreakPoints from "../hooks/useBreakPoints";

const Header = () => {
  const { callCategotyAPI, allCategory, token, allCart } =
    useContext(MyContext);
  const { isMobile, isTablet } = useBreakPoints();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [openId, setOpenId] = useState(null);
  const [isSticky, setIsSticky] = useState(false);
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [activeSubmenu, setActiveSubmenu] = useState("All");
  const [activeMobileSubmenu, setActiveMobileSubmenu] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  console.log(activeMobileSubmenu, "activeMobileSubmenu", activeSubmenu);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLoginClick = () => {
    if (token) {
      navigate("/userprofile");
    } else {
      setIsLoginModalOpen(true);
    }
  };

  const handleCloseLoginModal = () => {
    setIsLoginModalOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      // Adjust this scroll threshold as needed
      if (window.scrollY > 100) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    callCategotyAPI();
  }, [callCategotyAPI]);

  const handleCartClick = (e) => {
    e.preventDefault();
    setIsCartOpen(true);
  };

  const handleMouseEnter = (item) => {
    setActiveSubmenu(item);
  };

  const handleMouseLeave = () => {
    setActiveSubmenu(null);
  };

  const toggleMobileSubmenu = (item) => {
    setActiveMobileSubmenu(activeMobileSubmenu === item ? null : item);
  };

  console.log(allCategory, "allcategory");
  return (
    <header className="header">
      {/* Top Bar */}
      <div className="header-top-bar" style={{ backgroundColor: "#0d443e", color: "#fff", padding: "10px 0" }}>
        <div className="container" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div className="top-bar-left">
            <span style={{ fontSize: "14px", letterSpacing: "1px" }}>FLAT 30% OFF: CODE “TRISA26”</span>
          </div>
          <div className="top-bar-right" style={{ display: "flex", gap: "20px", alignItems: "center" }}>
            <button 
              className="action-btn" 
              style={{ color: "#fff" }}
              onClick={() => {
                // Toggle search or navigate
                if (window.innerWidth < 768) {
                  // Mobile behavior if needed or just same
                }
                // For now, simple prompt or keep existing search logic hidden until toggled? 
                // The task says "Search Icon". I will reuse the existing logic but maybe show/hide an input or navigate.
                // Let's just make it focus an existing input or toggle a search modal if we had one.
                // Since the UI shows just an icon, I'll assume it toggles a search mode or we can just keep the icon for now.
                // Re-using the navigation logic for now:
                navigate("/shop"); 
              }}
            >
              <Search size={20} />
            </button>
            <button
              className="action-btn"
              style={{ color: "#fff" }}
              onClick={() => navigate("/wishlist")}
            >
              <Heart size={20} />
            </button>
            <button className="action-btn" style={{ color: "#fff" }} onClick={() => setIsCartOpen(true)}>
              <ShoppingBag size={20} />
              {allCart?.length > 0 && <span className="badge" style={{ backgroundColor: "#fff", color: "#0d443e" }}>{allCart?.length}</span>}
            </button>
             <button className="action-btn" style={{ color: "#fff" }} onClick={handleLoginClick}>
              <User size={20} />
            </button>
          </div>
        </div>
      </div>

      <div className="header-main " style={{paddingTop: 0}}>
        <div className="container">
          
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", position: "relative" }}>
             {/* Mobile menu button */}
             <button className="mobile-menu-btn" onClick={toggleMenu}>
                {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
              </button>

            {/* Logo */}
            <div className="logo" style={{ margin: "10px auto", textAlign: "center", display: "flex", justifyContent : "center"  }}>
              <Link to="/">
                <img
                  src="/images/TRISA-LOGO.png"
                  alt="Pankaj Jewellers"
                  className="header-logo-img"
                  style={{ width: isMobile ? 150 : 250, height: 40, objectFit: "contain" }}
                />
              </Link>
            </div>
             
             {/* Placeholder for right side on mobile to balance logo if needed, or empty */}
             <div className="mobile-hidden-spacer" style={{ width: "24px", display: isMobile ? "block" : "none" }}></div>
          </div>
          

      {/* Navigation Menu */}
      <nav
        className={`navigation ${isMenuOpen ? "mobile-open" : ""}`}
        onMouseLeave={handleMouseLeave}
      >
        <div className="container">
          <ul className="nav-list">
            {allCategory?.map((item) => {
              const hasSubs = item?.SubCategories?.length > 0;
              const isOpen = activeSubmenu === item?.CategoryName;

              return (
                <li
                  key={item?.CategoryId}
                  className={`nav-item${isOpen ? " is-open" : ""}`}
                  onMouseEnter={() => {
                    if (!isMobile && hasSubs) {
                      handleMouseEnter(item?.CategoryName);
                    }
                  }}
                >
                  <Link
                    onClick={
                      isMobile
                        ? (e) => {
                            if (hasSubs) {
                              e.preventDefault();
                              toggleMobileSubmenu(item?.CategoryName);
                            } else {
                              setIsMenuOpen(false);
                            }
                          }
                        : () => setActiveSubmenu(null)
                    }
                    to={`/shop?catagoryId=${item?.CategoryId}`}
                    className="nav-link"
                  >
                    {item?.CategoryName}
                    {hasSubs && (
                      <span className="nav-link__chevron">
                        <ChevronDown size={14} />
                      </span>
                    )}
                  </Link>

                  {hasSubs && (
                    <div
                      className={`nav-dropdown${isOpen ? " is-visible" : ""}`}
                      onMouseEnter={() =>
                        setActiveSubmenu(item?.CategoryName)
                      }
                      onMouseLeave={handleMouseLeave}
                    >
                      <div className="nav-dropdown__panel">
                        <div className="nav-dropdown__head">
                          <span className="nav-dropdown__eyebrow">Shop</span>
                          <p className="nav-dropdown__title">
                            {item?.CategoryName}
                          </p>
                        </div>
                        <ul className="nav-dropdown__list">
                          {item?.SubCategories?.map((subItem, index) => (
                            <li key={subItem?.SubCategoryId || index}>
                              <Link
                                to={`/shop?catagoryId=${item?.CategoryId}&subCategoryId=${subItem?.SubCategoryId}`}
                                className="nav-dropdown__link"
                                onClick={() => setActiveSubmenu(null)}
                              >
                                {subItem?.SubCategoryName}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  )}

                  {activeMobileSubmenu === item?.CategoryName && (
                    <div className="mobile-submenu">
                      <div className="mobile-submenu-section">
                        <ul className="mobile-submenu-list">
                          {item?.SubCategories.map((subItem, index) => (
                            <li key={subItem?.SubCategoryId || index}>
                              <Link
                                to={`/shop?catagoryId=${item?.CategoryId}&subCategoryId=${subItem?.SubCategoryId}`}
                                className="mobile-submenu-link"
                                onClick={() => setIsMenuOpen(false)}
                              >
                                {subItem?.SubCategoryName}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      </nav>

      {/* {isCartOpen && ( */}
      <ShoppingCart isOpen={isCartOpen} onClose={() => setIsCartOpen(false)} />
      {/* )} */}

      <Authentication
        isOpen={isLoginModalOpen}
        onClose={() => setIsLoginModalOpen(false)}
      />
      {/* Dropdown Submenu */}
      {/* {activeSubmenu && ( */}

      {/* )} */}
      </div>
      </div>
    </header>
  );
};

export default Header;
